<template>
    <a-layout id="app" class="layout">
      <a-layout-header class="header">
        <img class="logo" src="/logo-large-dark.png" />
        <div id="nav">

          <router-link class="link" exact to="/">CONVERTER</router-link>
          <router-link class="link" exact to="/archive">ARCHIVE</router-link>
          <router-link v-if="isAdmin" class="link" exact to="/provenance">PROVENANCE</router-link>
          <router-link v-if="isAdmin" class="link" exact to="/administration">ADMINISTRATION</router-link>

        </div>
        <div class="profile">
          <a-button @click="localSignOut" icon="logout" type="link">Sign Out</a-button>
        </div>
      </a-layout-header>
      <a-layout-content class="content">
        <slot></slot>
      </a-layout-content>
    </a-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState("auth", ["userRole"]),

    isAdmin() {
      if (this.userRole == 'USER') {
        return false
      }
      return true
    }
  },
  methods: {
    ...mapActions('auth',['signOut']),
    localSignOut(){
      this.signOut()
      this.$router.push('/auth')
    
    }
  },
}
</script>

<style lang="scss" scoped>
#app .logo {
  height: 70%;
  margin: 0.5rem;
  float: left;
}

.ant-layout-header {
  display: flex;
  background: #fff;
  .profile{
    margin-left: auto;
  }
}

#nav {
  display: flex;
  align-items: center;
  & .link {
    color: #222377;
    padding: 0 16px;
    transition: 0.1s all ease-in-out;
    &.router-link-active {
      // background-color: #2196f3;
      color: rgba(0,103,252,1);
    }
  }
}

#app {
  font-size: 10px;
  font-family: "NH", "Helvetica", "Arial", sans-serif;
  font-weight: 700;
  .content{
    display: flex;
    flex-direction: column;
    flex:1 1 auto;
    min-height: 0;
    padding: 50px;
    @media (max-width: 1280px) { padding: 24px; }
    @media (max-height: 800px) { padding-top: 20px; padding-bottom: 20px; }
  }
}
</style>